import { literal, number, object, optional, type InferOutput } from "valibot"
import { InputBindingDevice } from "../InputBindingDevice.enum"

export const GamepadInputBindingSchema = object({
  device: literal(InputBindingDevice.Gamepad),
  button: number(),
  gamepadIndex: optional(number()),
})

export type GamepadInputBinding = InferOutput<typeof GamepadInputBindingSchema>
